export default __webpack_public_path__ + "static/media/PAT.89296374.svg";